(function () {
  if (window.individualQuoteModalBound) return;
  window.individualQuoteModalBound = true;

  var openModal = null;
  var lastTrigger = null;
  var scrollY = 0;
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(', ');

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function isVisible(element) {
    return element.offsetWidth > 0 || element.offsetHeight > 0 || element.getClientRects().length > 0;
  }

  function focusableElements(modal) {
    return Array.prototype.filter.call(modal.querySelectorAll(focusableSelector), function (element) {
      if (element.tabIndex < 0) return false;
      return isVisible(element);
    });
  }

  function lockScroll() {
    scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('individual-quote-open');
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.documentElement.classList.remove('individual-quote-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function openQuoteModal(modal, trigger) {
    if (!modal || modal === openModal) return;

    if (openModal) closeQuoteModal(openModal, true);

    openModal = modal;
    lastTrigger = trigger || null;
    modal.hidden = false;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    if (lastTrigger) lastTrigger.setAttribute('aria-expanded', 'true');

    lockScroll();

    window.setTimeout(function () {
      var success = modal.querySelector('[data-individual-quote-success]');
      var field = modal.querySelector('input:not([type="hidden"]):not([readonly]), textarea');
      var closeButton = modal.querySelector('[data-individual-quote-close]');
      var target = success || field || closeButton;
      if (target) target.focus();
    }, 0);
  }

  function closeQuoteModal(modal, skipFocus) {
    if (!modal) return;

    var trigger = lastTrigger;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;

    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    if (modal === openModal) {
      unlockScroll();
      openModal = null;
      lastTrigger = null;
    }

    if (!skipFocus && trigger && typeof trigger.focus === 'function') {
      trigger.focus();
    }

    resetQuoteForm(modal);
  }

  function resetQuoteForm(modal) {
    var message = modal.querySelector('[data-individual-quote-success-message]');
    var fields = modal.querySelector('[data-individual-quote-fields]');
    if (message) {
      message.hidden = true;
      message.removeAttribute('data-individual-quote-success');
    }
    if (fields) fields.hidden = false;
    Array.prototype.forEach.call(modal.querySelectorAll('form label, form input, form textarea, form button.btn, form .errors, form [data-individual-quote-errors], form p'), function (element) {
      if (element.hasAttribute('data-individual-quote-success-message')) return;
      if (element.type === 'hidden') return;
      element.hidden = false;
    });
  }

  function quoteTrigger(node) {
    var trigger = node && node.closest ? node.closest('[data-individual-quote-open]') : null;
    if (!trigger) return null;
    if (trigger.tagName === 'A' || trigger.tagName === 'BUTTON') return trigger;
    return trigger.querySelector('a[data-individual-quote-open], button[data-individual-quote-open]') || trigger;
  }

  document.addEventListener('click', function (event) {
    var trigger = quoteTrigger(event.target);
    if (trigger) {
      var modalId = trigger.getAttribute('aria-controls');
      var modal = modalId ? document.getElementById(modalId) : null;
      if (!modal) return;
      event.preventDefault();
      openQuoteModal(modal, trigger);
      return;
    }

    if (!openModal) return;

    if (event.target.closest('[data-individual-quote-close]')) {
      event.preventDefault();
      closeQuoteModal(openModal);
      return;
    }

    if (event.target === openModal) closeQuoteModal(openModal);
  });

  document.addEventListener('keydown', function (event) {
    if (!openModal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeQuoteModal(openModal);
      return;
    }

    if (event.key !== 'Tab') return;

    var items = focusableElements(openModal);
    if (!items.length) {
      event.preventDefault();
      return;
    }

    var first = items[0];
    var last = items[items.length - 1];

    var active = document.activeElement;
    var activeInside = items.indexOf(active) !== -1;

    if (event.shiftKey && (active === first || !activeInside)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !activeInside)) {
      event.preventDefault();
      first.focus();
    }
  });

  function quoteModalTrigger(modal) {
    return document.querySelector('[data-individual-quote-open][aria-controls="' + modal.id + '"]');
  }

  function revealQuoteSuccess(modal) {
    var message = modal.querySelector('[data-individual-quote-success-message]');
    var fields = modal.querySelector('[data-individual-quote-fields]');
    if (!message) return;
    message.hidden = false;
    message.setAttribute('data-individual-quote-success', '');
    if (fields) fields.hidden = true;
  }

  function clearQuotePending() {
    try {
      sessionStorage.removeItem('individualQuotePending');
    } catch (error) {}
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-individual-quote-unit]'), function (select) {
      var index = parseInt(select.getAttribute('data-option-index'), 10);
      var value = '';
      if (index === 1) value = variant.option1;
      else if (index === 2) value = variant.option2;
      else if (index === 3) value = variant.option3;
      if (!value && variant.title) value = variant.title;
      if (!value) return;
      var match = Array.prototype.some.call(select.options, function (option) {
        return option.value === value;
      });
      if (match) select.value = value;
    });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.id || form.id.indexOf('IndividualQuoteForm-') !== 0) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    try {
      sessionStorage.setItem('individualQuotePending', form.id);
    } catch (error) {}
  }, true);

  onReady(function () {
    var marker = document.querySelector('[data-individual-quote-success], [data-individual-quote-errors]');
    if (marker) {
      var markedModal = marker.closest('.individual-quote-modal');
      if (markedModal) {
        clearQuotePending();
        openQuoteModal(markedModal, quoteModalTrigger(markedModal));
      }
      return;
    }

    var pending = '';
    try {
      pending = sessionStorage.getItem('individualQuotePending') || '';
    } catch (error) {}
    if (!pending) return;

    var hash = '';
    try {
      hash = decodeURIComponent(window.location.hash || '').replace(/^#/, '');
    } catch (error) {
      hash = (window.location.hash || '').replace(/^#/, '');
    }
    var postedInUrl = false;
    try {
      postedInUrl = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    } catch (error) {}
    if (hash !== pending && hash.indexOf(pending) === -1 && !postedInUrl) return;

    var form = document.getElementById(pending);
    var modal = form && form.closest('.individual-quote-modal');
    if (!modal) return;
    clearQuotePending();
    revealQuoteSuccess(modal);
    openQuoteModal(modal, quoteModalTrigger(modal));
  });
})();
